import { render, staticRenderFns } from "./NewsLetterCheckbox.vue?vue&type=template&id=0843709a&"
import script from "./NewsLetterCheckbox.vue?vue&type=script&lang=js&"
export * from "./NewsLetterCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NewsLetterCheckbox.vue?vue&type=style&index=0&id=0843709a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports